import { MotionValue, motion, useSpring, useTransform } from 'framer-motion';
import './DropdownMenu.scss';
import { projects } from '../../helpers/constants';
import { scrollToSection } from '../../helpers/functions';
import React, { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';

export type DropdownMenuProps = { isVisible: boolean, closeMenuFunc: Function, scrollYProgress: MotionValue<number>, menuProgressRef?: React.Ref<HTMLDivElement> };
const DropdownMenu = ({ isVisible, closeMenuFunc, scrollYProgress, menuProgressRef = undefined }: DropdownMenuProps): JSX.Element => {
    const scrollYPercent = useTransform(useSpring(scrollYProgress, { stiffness: 200, damping: 25 }), [0, 3, 4], ['0%', '75%', '75%'], { clamp: false });
    const fadeProgressCircleAway = useTransform(scrollYProgress, [3.5, 3.75, 3.9], ['100%', '0%', '0%']);
    const fadeProgressCircleIn = useTransform(scrollYProgress, [-0.1, 3.75, 3.9], ['0', '0%', '100%']);
    const { pathname } = useLocation();

    return (
        <>
            <div className={`dropdown-menu ${isVisible ? 'visible' : ''}`}></div>
            <div className={`navigation-progress-desktop ${isVisible ? 'visible' : ''} ${pathname !== '/' ? 'otherpage' : ''}`} ref={menuProgressRef}>
                <div className="progress-circle-container">
                    <motion.div className="progress-circle" style={{ left: scrollYPercent, opacity: pathname === '/' ? fadeProgressCircleAway : 'revert-layer' }}></motion.div>
                    <motion.div className="progress-circle" style={{ left: '100%', opacity: fadeProgressCircleIn }}></motion.div>
                </div>
                <Link className="circle" to='/#home' onClick={e => {scrollToSection(e, 'home'); closeMenuFunc()}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="8.5" />
                    </svg>
                    <h3>Home</h3>
                </Link>
                <div className="line" style={{flex: projects.length + 1}}></div>
                <Link className="circle" to='/#about-me' onClick={e => {scrollToSection(e, 'about-me'); closeMenuFunc()}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="8.5" />
                    </svg>
                    <h3>About Me</h3>
                </Link>
                <div className="line" style={{flex: projects.length + 1}}></div>
                <Link className="circle" to='/#skills' onClick={e => {scrollToSection(e, 'skills'); closeMenuFunc()}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="8.5" />
                    </svg>
                    <h3>Skills</h3>
                </Link>
                <div className="line" style={{flex: projects.length + 1}}></div>
                <Link className="circle" to='/#projects' onClick={e => {scrollToSection(e, 'projects'); closeMenuFunc()}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="8.5" />
                    </svg>
                    <h3>Projects</h3>
                </Link>
                {
                    projects.map((e, i) => (
                        <Fragment key={i}>
                            <div className="dashed-line"></div>
                            <Link className="small-circle" to={`/#${e.title.replace(/\s/g,'-')}`} onClick={i === projects.length - 1 ? ev => {
                                    scrollToSection(ev, e.title.replace(/\s/g,'-'), 'end');
                                    closeMenuFunc();
                                } : ev => {
                                    scrollToSection(ev, e.title.replace(/\s/g,'-'));
                                    closeMenuFunc();
                                }}>
                                <p>{e.title}</p>
                            </Link>
                        </Fragment>
                    ))
                }
                <div className="dashed-line"></div>
                <Link className="circle" to='/#contact' onClick={e => {scrollToSection(e, 'contact'); closeMenuFunc()}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="8.5" />
                    </svg>
                    <h3>Contact</h3>
                </Link>
            </div>
        </>
    );
}

export default DropdownMenu;
